export default __webpack_public_path__ + "static/media/BMW.c4690b16.png";